import { ModLevel } from '@/models/engineering-models.model';
import { BinderService } from '@/services/api/binder.service';
import { ModLevelsService } from '@/services/api/mod-levels.service';
import { AppStateService } from '@/services/app/app-state.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { UserAccessService } from '@/services/app/user-access.service';
import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';
import { Binder } from 'src/app/models/binder.model';
import { BinderAssembliesService } from 'src/app/services/app/binder-assemblies.service';

@Component({
    selector: 'app-binder-engineering-fee',
    template: `
    <div class="flex flex-col gap-4">
                    <!-- <div class="font-semibold text-xl">Vertical</div> -->
                    <div class="flex flex-col gap-2">
                        <label for="name1">Mod Level</label>
                        <p-select [options]="modLevels" [(ngModel)]="selectedModId" optionLabel="ModName" optionValue="ModID" (onChange)="setMod($event.value)" [disabled]="checkFounders()"></p-select>
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="email1">Base Engineering</label>
                        <h3>{{selectedModCost | currency}}</h3>
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="age1">Additional Engineering</label>
                        <input id="customer_email" type="number" pInputText [(ngModel)]="additionalFee">
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="age1">Total Engineering</label>
                        <h3>{{selectedModCost + additionalFee | currency}}</h3>
                    </div>
                    <button pButton pRipple label="Save" icon="pi pi-file" class="w-auto" (click)="save()"></button>
                </div>
     `,
    styles: [
        `
    `
    ],
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        InputTextModule,
        ButtonModule
    ]
})
export class BinderEngineeringFeeComponent {
  originalMod!: ModLevel;
  originalFee: number = 0;
  selectedMod!: ModLevel | null;
  selectedModId: number = 2;
  selectedModCost: number = 0;
  additionalFee: number = 0;
  binderId!: number;
  engineeringAssemblyId!: number;


  constructor(
    private currentBinderService: BinderService,
    private binderDialogService: BinderDialogService,
    private messageService: MessageService,
    private binderService: BinderService,
    private binderAssembliesService: BinderAssembliesService,
    private userAccessService: UserAccessService,
    private learningModeService: AppStateService,
    private modLevelsService: ModLevelsService
  ) {
    effect(() => {
      const binder = this.currentBinderService.currentBinder();
      const binderAssemblies = this.binderAssembliesService.binderAssemblies();
      const mods = this.modLevelsService.modLevels()
      if(binder && mods) {
        this.binderId = binder.BinderID;
        this.setMod(binder.ModLevel ?? 2);
        this.additionalFee = binder.addEngineering ?? 0;
      }
      if(binderAssemblies) {
        this.setAssembly(binderAssemblies);
      }
    })
  }

  get modLevels() {
    const plan = this.currentBinderService.currentBinder().Plans;
    if(!plan) {
      return this.modLevelsService.modLevels().filter(mod => !mod.Archived);
    }
    if(plan.customPlan) {
      return this.modLevelsService.modLevels().filter(mod => !mod.Archived && mod.ModID > 3);
    }
    else if(plan.Archived) {
      return this.modLevelsService.modLevels().filter(mod => !mod.Archived && mod.ModID > 2);
    }
    return this.modLevelsService.modLevels().filter(mod => !mod.Archived);
  }

  checkFounders() {
    return this.userAccessService.foundersRestrictedAccess()
  }

  setAssembly(assemblies: BinderAssembly[]) {
    const assembly = assemblies.find(a => a.Type === 'F');
    console.log('assembly:', assembly);
    if(assembly) {
      this.engineeringAssemblyId = assembly.BAID;
      console.log('engineeringAssemblyId:', this.engineeringAssemblyId);
    }
  }

  resetMod() {
    this.setMod(this.originalMod.ModID);
    this.additionalFee = this.originalFee;
  }

  setOriginal(modId: number) {
    this.originalMod = this.modLevels.find(mod => mod.ModID === modId) ?? this.modLevels[0];
    this.originalFee = this.originalMod.ModCost ?? 0;
  }

  save() {
    const binderData = {
      addEngineering: this.additionalFee,
      ModLevel: this.selectedMod?.ModID ?? 2
    }

    let assemblyData: any = {
      Price: this.additionalFee + this.selectedModCost,
      Quantity: 1,
      Description: 'Fee for extra Drafting and Engineering beyond standard.',
      Name: 'Drafting Fee',
      Type: 'F',
      BinderID: this.binderId
    }

    if(this.learningModeService.learningMode()) {
      return;
    }

    console.log('engineeringAssemblyId:', this.engineeringAssemblyId);

    this.binderService.updateBinder(this.binderId, binderData).subscribe({
      next: (updatedBinder: Binder) => {
        this.currentBinderService.patchBinder(updatedBinder);
        console.log('binder updated', updatedBinder);
        if(this.additionalFee > 0 || this.selectedModCost > 0) {
        if(this.engineeringAssemblyId > 0) {
          if(this.selectedMod?.ModID === 1 && (this.additionalFee ===0 || this.additionalFee === null)) {
            console.log('deleting assembly:', this.engineeringAssemblyId)
            this.binderAssembliesService.removeAssembly(this.engineeringAssemblyId).subscribe({
              next: (deleted: BinderAssembly) => {
                console.log('assembly deleted', deleted);
                this.binderDialogService.toggleDialog('Engineering Fee', 'engineering', false);
              },
              error: (error: any) => {
                console.error('Error deleting assembly:', error);
              }
            });
          } else {
            console.log('updating assembly:', this.engineeringAssemblyId)
            this.binderAssembliesService.updateAssembly(this.engineeringAssemblyId,assemblyData).subscribe({
              next: (updated: BinderAssembly) => {
                console.log('assembly updated', updated);
                this.binderDialogService.toggleDialog('Engineering Fee', 'engineering', false);
              },
              error: (error: any) => {
                console.error('Error updating assembly:', error);
                this.messageService.add({severity:'error', summary: 'Error', detail: 'Error adding assembly', life: 3000});
              }
            });
          }
    
          
        } else {
          const sameCategoryAssemblies = this.binderAssembliesService.binderAssemblies().filter(binderAssembly => binderAssembly.CategoryID === 321);
        const maxPrintOrder = Math.max(...sameCategoryAssemblies.map(a => a.PrintOrder), 0);
          assemblyData.Categories = {
            connect: {
              CategoryID: 321
            }
          }
          assemblyData.Binders = {
            connect: {
              BinderID: this.binderId
            }
          }
          assemblyData.PrintOrder = maxPrintOrder + 1;
          console.log('adding assembly', assemblyData);
    
          this.binderAssembliesService.addAssembly(assemblyData).subscribe({
            next: (updated: BinderAssembly) => {
              console.log('assembly updated', updated);
              this.binderDialogService.toggleDialog('Engineering Fee', 'engineering', false);
            },
            error: (error: any) => {
              console.error('Error updating assembly:', error);
              this.messageService.add({severity:'error', summary: 'Error', detail: 'Error adding assembly', life: 3000});
            }
          });
        }
      } else {
        if(this.engineeringAssemblyId > 0) {
          this.binderAssembliesService.removeAssembly(this.engineeringAssemblyId).subscribe({
            next: (deleted: BinderAssembly) => {
              console.log('assembly deleted', deleted);
              this.binderDialogService.toggleDialog('Engineering Fee', 'engineering', false);
            },
          });
        };
        this.binderDialogService.toggleDialog('Engineering Fee', 'engineering', false);
      }
      },
      error: (error) => {
        console.error('Error updating binder:', error);
      }
    }
    
    );

  }

  // updateBinder(binderData:any) {
  //   this.binderService.updateBinder(this.binderId, binderData).subscribe((updatedBinder) => {
  //     this.currentBinderService.patchBinder(updatedBinder);
  //   });
  // }

  setMod(modId: number) {
    const mod = this.modLevels.find(mod => mod.ModID === modId);
    if(!mod) {
      this.selectedModId = modId;
      this.selectedMod = null;
      this.selectedModCost = 0;
      return;
    }
    this.selectedModId = modId;
    this.selectedMod = mod;
    this.selectedModCost = mod.ModCost || 0;
  }

}
